/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsCycle } from '../../models/submissions-cycle';

export interface UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Params {
  id: string;
  formVersion: string;
  org: string;
}

export function updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch(http: HttpClient, rootUrl: string, params: UpdateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
  const rb = new RequestBuilder(rootUrl, updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('formVersion', params.formVersion, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsCycle>;
    })
  );
}

updateSubmissionsCycleFormVersionInternalV2SubmissionsCycleIdFormVersionPatch.PATH = '/_internal/v2/submissions-cycle/{id}/form-version';
